export default __webpack_public_path__ + "static/media/Avia_Icon.8d32207a.png";